import {Injectable} from "@angular/core";
import {ErrorService} from "./Error.service";
import {PersistenceService} from "./Persistence.service";
import {LoaderService} from "./loader.service";
import {SuccessService} from "./success.service";

@Injectable()
export class AppUtilityService{
  constructor(private error:ErrorService,private persistence:PersistenceService,private loader:LoaderService,private success:SuccessService) {
  }
  public errorService(){
    return this.error;
  }
  public persistenceService(){
    return this.persistence;
  }
  public loaderService(){
    return this.loader;
  }
  public successService(){
    return this.success;
  }
  public exportCSV(data:any[],fileName:any){
    const replacer = (key:any, value:any) => (value === null ? '' : value);
    const header = Object.keys(data[0]);

    const csv = data.map((row) => header.map((fieldName) => JSON.stringify(row[fieldName], replacer)).join(','));

    csv.unshift(header.join(','));
    const csvArray = csv.join('\r\n');

    const a = document.createElement('a');
    const blob = new Blob([csvArray], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    a.href = url;

    a.download = fileName+ '.csv';
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }
  public downloadByLink(link:any){
    const a = document.createElement('a');
    a.href = link;
    // a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    a.remove();
    // link.revokeObjectURL(a);
  }
  public filterDefault(){
    var currentDate = new Date();
    const month=currentDate.toLocaleDateString('default', { month: 'long' })
    const year=currentDate.getFullYear()
    let date = currentDate.getDate() <= 9 ? '0' + currentDate.getDate() : currentDate.getDate();
    let monthNo = (currentDate.getMonth() + 1) <= 9 ? '0' + (currentDate.getMonth() + 1) : (currentDate.getMonth() + 1);
    let hour = currentDate.getHours() <= 9 ? '0' + currentDate.getHours() : currentDate.getHours();
    let minutes = currentDate.getMinutes() <= 9 ? '0' + currentDate.getMinutes() : currentDate.getMinutes();
    var second = currentDate.getSeconds() <= 9 ? '0' + currentDate.getSeconds() : currentDate.getSeconds();
    var start = currentDate.getFullYear() + '-' + monthNo +'-01T00:00:00';
    var end = currentDate.getFullYear() + '-' + monthNo + '-' + date + 'T' + hour + ':' + minutes + ':' + second;
    return {
      startDate: start,
      endDate: end
    }
  }
  public async saveAsStream(
  stream: any,
  dataType: any,
  fileName: string
): Promise<void> {

  const byteCharacters = atob(stream);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: dataType });

  // Allow user to choose filename/location
  if ('showSaveFilePicker' in window) {

    const handle = await (window as any).showSaveFilePicker({
      suggestedName: fileName,
      types: [
        {
          description: 'PDF File',
          accept: {
            'application/pdf': ['.pdf']
          }
        }
      ]
    });

    const writable = await handle.createWritable();

    await writable.write(blob);
    await writable.close();

    return;
  }

  // Fallback for browsers that don't support showSaveFilePicker
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.click();
  a.remove();

  URL.revokeObjectURL(url);
}

public downloadStream(stream:any,dataType:any,fileName:any){
    /*if(!stream||!dataType||!fileName) {
      this.error.showErrorToast("there was a problem downloading file.")
      return
    }*/
      const file="data:"+dataType+";base64,"+stream;
      const a =document.createElement('a');
      a.href=file;
      a.download=fileName;
      a.click();
      a.remove();
  }
}
